import React, { useState, useEffect } from "react";
import axios from "axios";
import Api from "../Api/Api.json";
var userid = 0;

const DoctorReviewNotes = ({ patient_id }) => {
	const [commentsList, setCommentsList] = useState([]);

	useEffect(() => {
		const headers = { headers: { "Content-Type": "application/json" } };
		const url = Api.TELEDOC_PROVIDER_API;
		const requestData = {
			task: "getPatientNotes",
			patient_id: patient_id,
			doctor_review_note: true,
		};
		axios
			.post(url, requestData, headers)
			.then((response) => {
				//console.log(response.data)
				if (response.data.length > 0) {
					setCommentsList(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
			});
	}, []);

	const submitComment = () => {
		const comment = document.getElementById("input_comment").value;
		// Check if the comment is empty
		if (!comment) {
			alert("Please enter a comment");
			return;
		}

		const headers = { headers: { "Content-Type": "application/json" } };
		const url = Api.TELEDOC_PROVIDER_API;
		const requestData = {
			task: "createPatientNotes",
			patient_id: patient_id,
			doctor_review_note: comment,
		};
		axios
			.post(url, requestData, headers)
			.then((response) => {
				//console.log(response.data)
			})
			.catch((error) => {
				console.log(error);
			});
	};

	return (
		<div>
			<p>Review Notes:</p>

			<table>
				<thead>
					<tr>
						<th>Time</th>
						<th>Note</th>
					</tr>
				</thead>
				<tbody>
					{commentsList.map((item) => (
						<tr key={item.id}>
							<td>{item.timestamp}</td>
							<td>{item.note}</td>
						</tr>
					))}
				</tbody>
			</table>
			<input id="input_comment" type="text" />
			<button
				className="btn btn-primary mt-2"
				onClick={() => submitComment()}
			>
				Submit
			</button>
		</div>
		//</div>
	);
};

export default DoctorReviewNotes;
